import { EditorView } from "codemirror";

const base = {
    "&": {
        fontSize: "13px",
    },
    ".cm-content": {
        backgroundColor: "oklch(94.81% 0.004 39.48)",
    },
};

export const mono = EditorView.theme({
    ...base,
    ".cm-content": {
        ...base[".cm-content"],
        fontFamily: "Zenbones Mono Web",
    },
    ".cm-gutter": {
        fontFamily: "Zenbones Mono Web",
    },
});

export const brainy = EditorView.theme({
    ...base,
    ".cm-content": {
        ...base[".cm-content"],
        fontFamily: "Zenbones Brainy Web",
    },
    ".cm-gutter": {
        fontFamily: "Zenbones Brainy Web",
    },
});

export const prose = EditorView.theme({
    ...base,
    ".cm-content": {
        ...base[".cm-content"],
        fontFamily: "Zenbones Prose Web",
    },
    ".cm-gutter": {
        fontFamily: "Zenbones Prose Web",
    },
});

export const proto = EditorView.theme({
    ...base,
    ".cm-content": {
        ...base[".cm-content"],
        fontFamily: "Zenbones Proto Web",
    },
    ".cm-gutter": {
        fontFamily: "Zenbones Proto Web",
    },
});

export const slab = EditorView.theme({
    ...base,
    ".cm-content": {
        ...base[".cm-content"],
        fontFamily: "Zenbones Slab Web",
    },
    ".cm-gutter": {
        fontFamily: "Zenbones Slab Web",
    },
});
